import { Mail, MapPin, Phone } from "lucide-react";
import { WHATSAPP_URL, EMAIL, PHONE_DISPLAY } from "../data/services";

export const Footer = () => {
    return (
        <footer className="bg-navy text-cream pt-20 pb-10">
            <div className="max-w-7xl mx-auto px-6 md:px-12">
                <div className="grid md:grid-cols-3 gap-12 mb-16">
                    <div>
                        <p className="font-display text-3xl font-bold mb-4">
                            AS<span className="text-coral">.</span>Studio
                        </p>
                        <p className="text-cream/60 text-sm leading-relaxed max-w-xs">
                            Agencia digital de grabación de vídeo, fotografía, gestión de redes
                            sociales y diseño web.
                        </p>
                    </div>
                    <div>
                        <p className="font-mono text-xs uppercase tracking-[0.25em] text-coral mb-5">Contacto</p>
                        <ul className="space-y-3 text-sm">
                            <li>
                                <a data-testid="footer-whatsapp" href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:text-coral transition-colors duration-300">
                                    <Phone size={15} /> {PHONE_DISPLAY} (WhatsApp)
                                </a>
                            </li>
                            <li>
                                <a data-testid="footer-email" href={`mailto:${EMAIL}`} className="flex items-center gap-2 hover:text-coral transition-colors duration-300">
                                    <Mail size={15} /> {EMAIL}
                                </a>
                            </li>
                            <li className="flex items-center gap-2 text-cream/60">
                                <MapPin size={15} /> Alicante, España
                            </li>
                        </ul>
                    </div>
                    <div>
                        <p className="font-mono text-xs uppercase tracking-[0.25em] text-coral mb-5">Servicios</p>
                        <ul className="space-y-2 text-sm text-cream/70">
                            <li><a href="#grabacion" className="hover:text-coral transition-colors duration-300">Grabación de vídeo en Alicante</a></li>
                            <li><a href="#fotografia" className="hover:text-coral transition-colors duration-300">Fotografía profesional</a></li>
                            <li><a href="#edicion" className="hover:text-coral transition-colors duration-300">Edición de vídeo</a></li>
                            <li><a href="#redes" className="hover:text-coral transition-colors duration-300">Gestión de redes sociales</a></li>
                            <li><a href="#web" className="hover:text-coral transition-colors duration-300">Diseño de sitios web</a></li>
                            <li><a href="#guiones" className="hover:text-coral transition-colors duration-300">Guiones e ideas</a></li>
                        </ul>
                    </div>
                </div>

                <p className="text-cream/40 text-xs leading-relaxed border-t border-cream/10 pt-8 mb-6">
                    AS Studio — Agencia de grabación de vídeo, fotografía, edición, gestión de
                    redes sociales y diseño de sitios web en Alicante. Trabajamos con negocios de
                    Alicante y toda la provincia — Elche, Benidorm, Torrevieja, Alcoy, Elda,
                    Villena — y con clientes en toda España.
                </p>
                <div className="flex flex-col md:flex-row justify-between gap-3 font-mono text-[11px] uppercase tracking-[0.2em] text-cream/40">
                    <span>© {new Date().getFullYear()} AS Studio</span>
                    <span>Alicante — Costa Blanca — España</span>
                </div>
            </div>
        </footer>
    );
};
